import { Reveal, SectionHeading } from "./Reveal";
import { WHY_ITEMS } from "../data/content";

export const WhyChoose = () => (
  <section id="why" data-testid="why-us-section" className="noise-overlay relative bg-navy-950 py-24 lg:py-32">
    <div className="mx-auto max-w-7xl px-4 sm:px-8 lg:px-16">
      <SectionHeading
        overline="Why Choose Faithh"
        testId="why-heading"
        title={
          <>
            Built different, <span className="text-gold-metallic italic">on purpose</span>
          </>
        }
        description="Most agencies sell services. We build partnerships — with the honesty, craft and attention your business deserves."
      />

      <div className="mt-16 grid grid-cols-1 gap-6 sm:grid-cols-2 lg:grid-cols-3 lg:gap-8">
        {WHY_ITEMS.map((item, i) => {
          const Icon = item.icon;
          return (
            <Reveal key={item.title} delay={(i % 3) * 0.09} className="h-full">
              <article
                data-testid={`why-card-${i + 1}`}
                className="card-lift group relative h-full rounded-3xl border border-white/8 bg-navy-900/70 p-8"
              >
                <span className="absolute right-7 top-6 font-display text-5xl font-bold text-white/[0.05] transition-colors duration-500 group-hover:text-gold/15">
                  {String(i + 1).padStart(2, "0")}
                </span>
                <span className="mb-6 inline-flex h-12 w-12 items-center justify-center rounded-2xl border border-gold/25 bg-gold/8 transition-all duration-500 group-hover:bg-gold/15 group-hover:shadow-[0_0_28px_rgba(212,175,55,0.25)]">
                  <Icon className="h-6 w-6 text-gold transition-transform duration-500 group-hover:scale-110" />
                </span>
                <h3 className="font-display text-xl sm:text-2xl font-semibold text-slate-50">{item.title}</h3>
                <p className="mt-3 text-sm leading-relaxed text-slate-400">{item.text}</p>
              </article>
            </Reveal>
          );
        })}
      </div>
    </div>
  </section>
);
